import { render } from "./QuestionThirteen.vue?vue&type=template&id=4d0ae41c"
import script from "./QuestionThirteen.vue?vue&type=script&lang=js"
export * from "./QuestionThirteen.vue?vue&type=script&lang=js"

import "./QuestionThirteen.vue?vue&type=style&index=0&id=4d0ae41c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__